import { render, staticRenderFns } from "./set.vue?vue&type=template&id=53464e7a&scoped=true&"
import script from "./set.vue?vue&type=script&lang=js&"
export * from "./set.vue?vue&type=script&lang=js&"
import style0 from "./set.vue?vue&type=style&index=0&id=53464e7a&prod&lang=scss&scoped=true&"
import style1 from "./set.vue?vue&type=style&index=1&id=53464e7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53464e7a",
  null
  
)

export default component.exports